// src/redux/suspensionReasonsSlice.ts
// 中断理由
import { createSlice} from '@reduxjs/toolkit';
import { AnyAction, Dispatch } from "redux";
import apiAxios from '../utils/apiAxios';
import { appendAlert } from "../redux/alertSlice"

// API GET /work_suspension_reasonsのデータ型
type SuspensionReasonsByLanguage = {
  ja: string,
  en?: string,
  vi?: string,
  zh?: string, 
  id?: string 
};

type SuspensionReason = {
  suspension_code: string,
  suspension_reason: SuspensionReasonsByLanguage,
};

type SuspensionReasons = {
  suspensionReasons:SuspensionReason[],
};

// 初期値
const initialState:SuspensionReasons = {
  suspensionReasons : [],
}

export const suspensionReasonsSlice = createSlice({
  name: 'SuspensionReason',
  initialState, 
  reducers: {
    setSuspensionReasons: (state, {payload}) => {
      state.suspensionReasons = payload;
    },
  },
});

const {setSuspensionReasons} = suspensionReasonsSlice.actions;

// 中断理由一覧取得
const fetchSuspensionReasons = () => {
  return async (dispatch:Dispatch<AnyAction>) => {
    try {
      const response = await apiAxios.get(`/work_suspension_reasons`);
      const data = response.data;
      dispatch(setSuspensionReasons(data));
    } catch (error:any) {
      console.error(error);
      dispatch(appendAlert({
        severity:"error",
        message:"データの取得に失敗しました。" + error.message,
        displayTime: 5000
      },));
    }
  }
}

export {fetchSuspensionReasons, setSuspensionReasons}
export default suspensionReasonsSlice.reducer;
